import { isNative } from './platform';

let cameraModule = null;

async function loadCamera() {
  if (cameraModule) return cameraModule;
  const mod = await import('@capacitor/camera');
  cameraModule = mod;
  return mod;
}

export async function pickProfileImage() {
  if (!isNative()) return null;
  const { Camera, CameraResultType, CameraSource } = await loadCamera();
  try {
    const photo = await Camera.getPhoto({
      quality: 85,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Prompt,
      promptLabelHeader: 'Photo de profil',
      promptLabelPhoto: 'Depuis la galerie',
      promptLabelPicture: 'Prendre une photo',
      promptLabelCancel: 'Annuler',
    });
    return photo.dataUrl;
  } catch (e) {
    if (e?.message?.toLowerCase?.().includes('cancel')) return null;
    console.warn('Camera error', e);
    return null;
  }
}
